export default __webpack_public_path__ + "media/images/farm-permission-63db9efc680f1798904bf7a90060302c.png";